import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import config from "config/config";
import { isFlagEnabled } from "js/utilities";

const useLogger = () => {
  const logger = useAppInsightsContext();

  return {
    trackEvent: (eventName, customProperties) => {
      if (
        isFlagEnabled("ENABLE_LOGGING") &&
        config.APP_INSIGHTS_CONNECTION_STRING
      ) {
        return logger.trackEvent({ name: eventName }, customProperties);
      }
    },
  };
};

export default useLogger;
